import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 4C2633A8-8E84-4301-A470-0408DCFFEEF8
 * name credit-card-refund-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-refund-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardRefundOutlineIcon = createSvgIcon(<><path d="M18,11H6A2,2 0 0,0 4,13V21A2,2 0 0,0 6,23H18A2,2 0 0,0 20,21V13A2,2 0 0,0 18,11M18,21H6V17H18V21M18,15H6V13H18V15M17,5V10H15.5V6.5H9.88L12.3,8.93L11.24,10L7,5.75L11.24,1.5L12.3,2.57L9.88,5H17Z" /></>, 'CreditCardRefundOutlineIcon');
export default CreditCardRefundOutlineIcon